import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { bind } from 'bind-event-listener';
import { logException } from '@atlaskit/editor-common/monitoring';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
import { setDatePickerAt } from '../pm-plugins/actions';
import { dateToDOM } from './dateNodeSpec';
export var DateNodeView = /*#__PURE__*/function () {
  function DateNodeView(node, view, getPos, intl) {
    _classCallCheck(this, DateNodeView);
    _defineProperty(this, "dom", document.createElement('span'));
    this.node = node;
    try {
      var spec = dateToDOM(node, view.state, getPos, intl);
      var _DOMSerializer$render = DOMSerializer.renderSpec(document, spec),
        dom = _DOMSerializer$render.dom;
      if (!(dom instanceof HTMLElement)) {
        throw new Error('DOMSerializer.renderSpec() did not return HTMLElement');
      }
      this.dom = dom;
      this.clickUnBind = bind(this.dom, {
        type: 'click',
        listener: function listener(event) {
          event.stopImmediatePropagation();
          var state = view.state,
            dispatch = view.dispatch;
          setDatePickerAt(state.selection.from)(state, dispatch);
        }
      });
    } catch (error) {
      DateNodeView.logError(error instanceof Error ? error : new Error('Unknown error on DateNodeView constructor'));
      this.renderFallback();
    }
  }
  return _createClass(DateNodeView, [{
    key: "renderFallback",
    value: function renderFallback() {
      var fallbackElement = document.createElement('span');
      fallbackElement.innerText = this.node.attrs.timestamp;
      this.dom.appendChild(fallbackElement);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clickUnBind && this.clickUnBind();
    }
  }], [{
    key: "logError",
    value: function logError(error) {
      void logException(error, {
        location: 'editor-plugin-date/DateNodeView'
      });
    }
  }]);
}();